import React from 'react';
import { Route } from 'react-router';
import CommentEditPage from './containers/comment-edit-page';
import CommentEditPageHeader from './containers/comment-edit-page-header';
import CategoryDesktopHeader from './containers/category-desktop-header';
import PostEditorPageOrModal from './containers/post-editor-page-or-modal';
import PostPage from './containers/post-page';
import PostMobileHeader from './containers/post-mobile-header';
import requireAuth from './hoc/require-auth';
import requireNotBlocked from './hoc/require-not-blocked';
import withPerformanceTracking from './hoc/with-performance-tracking';
import { isPostPageBundle } from './services/section-route-utils';
import { isValidAdvancedSlug } from './services/slug';

export const validateAdvancedSlug = ({ params }, replace) => {
  if (!isValidAdvancedSlug(params)) {
    replace({ pathname: '/404' });
  }
};

const PostPageWithPerformanceTracking = withPerformanceTracking({
  context: 'communities-blog-post-page',
  skip: () => !isPostPageBundle(),
})(PostPage);

const PostSubRoutes = [
  <Route
    key={'edit-post'}
    path="edit"
    name="Edit Post"
    components={{
      main: PostEditorPageOrModal,
      desktopHeader: CategoryDesktopHeader,
    }}
  />,
  <Route
    key={'preview-post'}
    path="preview/:instance"
    name="Preview Post"
    components={{
      main: requireAuth(requireNotBlocked(PostPage)),
      mobileHeader: PostMobileHeader,
      desktopHeader: CategoryDesktopHeader,
    }}
  />,
  <Route
    key={'edit-comment'}
    path="edit-comment/:commentId"
    name="Edit Comment"
    components={{
      main: requireAuth(requireNotBlocked(CommentEditPage)),
      mobileHeader: CommentEditPageHeader,
      desktopHeader: CategoryDesktopHeader,
    }}
  />,
];

export const PostRoutes = [
  <Route
    key={'simple'}
    path=":postSlug"
    name="Post"
    components={{
      main: PostPageWithPerformanceTracking,
      mobileHeader: PostMobileHeader,
      desktopHeader: CategoryDesktopHeader,
    }}
  />,
  <Route key={'simple-subroutes'} path=":postSlug" name="Post">
    {PostSubRoutes}
  </Route>,
  <Route
    key={'advanced'}
    path=":year/:month(/:day)/:postSlug(/)"
    name="Post"
    onEnter={validateAdvancedSlug}
    components={{
      main: PostPageWithPerformanceTracking,
      mobileHeader: PostMobileHeader,
      desktopHeader: CategoryDesktopHeader,
    }}
  />,
  <Route key={'advanced-subroutes'} path=":year/:month(/:day)/:postSlug(/)" name="Post">
    {PostSubRoutes}
  </Route>,
];
